export const ChevronLeftIcon = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
    <path d="M7.08203 10.0834L3.07161 5.50004L7.08203 0.916707" stroke="currentColor" strokeLinecap="round"/>
  </svg>
)
